// src/pages/Consultation1HourPage.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import PaymentDetails from '../components/PaymentDetails';
// ✅ CORRECCIÓN CSS: Usamos el archivo general para evitar el error de compilación
import './ConsultationPage.css'; 

const Consultation1HourPage = () => {
    const navigate = useNavigate();

    const serviceName = "Análisis Profundo";
    const serviceTag = "1 Hora";
    const price = "$190.00 USD";
    
    // Descripción basada en el contexto anterior
    const serviceDescription = "Ideal para un análisis más profundo. Discute tus inquietudes en detalle y recibe asesoría personalizada.";

    return (
        <div className="page-container consultation-detail-page">
            <header className="service-header">
                {/* Asumo que tienes un ícono aquí (puedes ajustarlo si tienes uno específico) */}
                <div className="service-icon-large">⏳</div> 
                <h2>Adquiere: {serviceName} ({serviceTag})</h2>
                <h1 className="service-price-tag">{price}</h1>
                <p className="service-description">{serviceDescription}</p>
            </header>
            
            {/* Asumiendo que PaymentDetails es el componente que muestra los métodos de pago */}
            <PaymentDetails 
                price={price} 
                serviceName={serviceName} 
            />

            {/* ✅ CORRECCIÓN DE RUTA: El botón de retorno navega a /servicios */}
            <button 
                className="back-button"
                onClick={() => navigate('/servicios')} 
            >
                <FiArrowLeft /> Volver a Servicios
            </button>
        </div>
    );
};

export default Consultation1HourPage; 